/** Sales-Aktionen als eigener Hauptmenüpunkt unter „Katalog & Sales".
 *  Die Pflege selbst liegt weiterhin in genau einer Komponente (SalesPromotionsTab). */
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { useI18n } from "@/i18n";
import SalesPromotionsTab from "@/components/b2b/SalesPromotionsTab";

export default function SalesPromotionsPage() {
  const { user } = useAuth();
  const { t } = useI18n();
  return (
    <div data-testid="sales-promotions-page">
      <PageHeader title={t("sp.tab")} />
      <SalesPromotionsTab canEdit={user?.role === "admin"} />
    </div>
  );
}
